import React from 'react';
import { fromJS } from 'immutable';
import { hydrateRoot } from 'react-dom/client';

import createHistory from 'history/createBrowserHistory.js';
import configureStore from '../universal/state/configureStore.js';

import App from './App.jsx';

// Grab the state from a global variable injected into the server-generated HTML
const preloadedState = fromJS(window.__PRELOADED_STATE__);

// Allow the passed state to be garbage-collected
delete window.__PRELOADED_STATE__;

// Create Redux store with initial state
const history = createHistory();
const store = configureStore({ history, preloadedState });

const render = (Component) => {
    hydrateRoot(
        document.getElementById('root'),

        <Component store={store} history={history} />
        ,
    );
};

render(App);

// Only enable in development env
if (module.hot) {
    module.hot.accept('./App', () => {
        const NextRoot = require('./App').default;
        render(NextRoot);
    });
}
